export default {
    SET_CREDENTIALS: (state, action) => {
        return state.set(action.payload.credentialType, action.payload.value);
    },
    LOGIN_REQUEST: (state, action) => {
        return state.set("loggingIn", true);
    },
    LOGIN_SUCCESS: (state, action) => {
        return state.set("loggingIn", false).merge(action.payload);
    },
    LOGIN_FAILURE: (state, action) => {
        return state.set("loggingIn", false);
    }
};
